import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './component/Auth/Login';
import Dashboard from './component/Dashboard';
import Booking from './component/Booking';
import InvestorList from './component/InvestorList';
import AddInvestor from './component/Add Model/AddInvestor';
import InvestorEarning from './component/InvestorEarning';
import InvestorWithdrawal from './component/InvestorWithdrawal';
import CottageList from './component/CottageList';
import AddNewCottage from './component/Add Model/AddNewCottage';
import CouponCode from './component/CouponCode';
import AddNewCouponCode from './component/Add Model/AddNewCouponCode';
import CouponUserManagement from './component/CouponUserManagement';
import InventoryList from './component/InventoryList';
import AddRoom from './component/Add Model/AddRoom';
import ManageReview from './component/ManageReview';
import FaqList from './component/FaqList';
import AddFAQ from './component/Add Model/AddFaq';
import FaqCategory from './component/FaqCategory';
import AddFAQCategory from './component/Add Model/AddFaqCategory';
import Contact from './component/Contact';
import Header from './component/Header/Header';
import Footer from './component/Header/Footer';
import SideBar from './component/Header/SideBar';
import UserManager from './component/UserManager';
import Notification from './component/Notification';
import AddNotification from './component/Add Model/AddNotification';

import AddBanner from './component/Add Model/AddBanner';
import UserAdd from './component/Add Model/UserAdd';
import Banner from './component/Banner';
import Category from './component/Category';
import AddCategory from './component/Add Model/AddCategory';


import Profile from './component/Profile';
import PrivacyPolicy from './component/PrivacyPolicy';
import TermCondition from './component/TermAndCondition';
import Feedback from './component/Feedback';
import AddAdmin from './component/Add Model/AddAdmin';
import AdminUser from './component/AdminUser';
import PushNotification from './component/PushNotification';
import PushNotificationList from './component/PushNotificationList';


import RefundPolicy from './component/RefundPolicy';

import TrialPeriod from './component/TrialPeriod';
import AppSettings from './component/AppSettings';
import EmailNotification from './component/EmailNotification';
import TicketManagement from './component/TicketManagement';
import UserPermission from './component/UserPermission';
import Refer from './component/Refer';

const PrivateRoute = ({ children, isAuthenticated, requiredPermission, isAdmin }) => {
  const permissions = JSON.parse(localStorage.getItem('userPermissions')) || {};

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Or any other loading indicator
  }
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  if (!isAdmin && !permissions[requiredPermission]) {
    return <Navigate to="/dashboard" />; // Or an appropriate "not authorized" page
  }
  return children;
};
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [role, setRole] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    // Check if the user is authenticated and get their role
    const token = localStorage.getItem('authToken');
    const userRole = localStorage.getItem('userRole'); // Assuming role is stored in local storage
    if (token && userRole) {
      setIsAuthenticated(true);
      setRole(userRole);
      setIsAdmin(userRole === 'Admin');
    } else {
      setIsAuthenticated(false);
    }
  }, [role]);

  return (
    <Router>
      {isAuthenticated && <Header />}
      <Routes>
      
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <Login setIsAuthenticated={setIsAuthenticated} setRole={setRole} />
          }
        />
        {/* <Route
          path="/dashboard"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <Login setIsAuthenticated={setIsAuthenticated} setRole={setRole} />
          }
        /> */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="dashboard" isAdmin={isAdmin}>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/user-permission"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="user-permission" isAdmin={isAdmin}>
              <UserPermission />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-manager"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="user-manager" isAdmin={isAdmin}>
              <UserManager />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/booking"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="booking" isAdmin={isAdmin}>
              <Booking />
            </PrivateRoute>
          }
        />
        <Route
          path="/investor-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="investor-management" isAdmin={isAdmin}>
              <InvestorList />
            </PrivateRoute>
          }
        />
       <Route
          path="/add-investor"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="investor-management" isAdmin={isAdmin}>
              <AddInvestor />
            </PrivateRoute>
          }
        />
        <Route
          path="/investor-earning"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="investor-management" isAdmin={isAdmin}>
              <InvestorEarning />
            </PrivateRoute>
          }
        />
        <Route
          path="/investor-withdrawal"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="investor-management" isAdmin={isAdmin}>
              <InvestorWithdrawal />
            </PrivateRoute>
          }
        />
       <Route
          path="/cottage-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="cottage-list" isAdmin={isAdmin}>
              <CottageList />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-new-cottage"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="cottage-list" isAdmin={isAdmin}>
              <AddNewCottage />
            </PrivateRoute>
          }
        />
<Route
          path="/coupon-code"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon-code" isAdmin={isAdmin}>
              <CouponCode />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-new-coupon-code"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon-code" isAdmin={isAdmin}>
              <AddNewCouponCode />
            </PrivateRoute>
          }
        />
        <Route
          path="/coupon-user-management"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="coupon" isAdmin={isAdmin}>
              <CouponUserManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventory-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="inventory-list" isAdmin={isAdmin}>
              <InventoryList />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-room"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="inventory-list" isAdmin={isAdmin}>
              <AddRoom />
            </PrivateRoute>
          }
        />
        <Route
          path="/manage-review"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="manage-review" isAdmin={isAdmin}>
              <ManageReview />
            </PrivateRoute>
          }
        />
        <Route
          path="/faq-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="help" isAdmin={isAdmin}>
              <FaqList />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-faq"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="help" isAdmin={isAdmin}>
              <AddFAQ />
            </PrivateRoute>
          }
        />
         <Route
          path="/faq-category-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="help" isAdmin={isAdmin}>
              <FaqCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-faq-category"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="help" isAdmin={isAdmin}>
              <AddFAQCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="help" isAdmin={isAdmin}>
              <Contact />
            </PrivateRoute>
          }
        />
        <Route
          path="/ticket-management"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="help" isAdmin={isAdmin}>
              <TicketManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-add"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="user-manager" isAdmin={isAdmin}>
              <UserAdd />
            </PrivateRoute>
          }
        /> 
        <Route
          path="/privacy-policy"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <PrivacyPolicy />
            </PrivateRoute>
          }
        />
          <Route
          path="/term-and-condition"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <TermCondition />
            </PrivateRoute>
          }
        />
        <Route
          path="refund-policy"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="pages" isAdmin={isAdmin}>
              <RefundPolicy />
            </PrivateRoute>
          }
        />
         
         
        
        <Route
          path="/notification-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="notification-list" isAdmin={isAdmin}>
              <Notification />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-notification"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="notification-list" isAdmin={isAdmin}>
              <AddNotification />
            </PrivateRoute>
          }
        />
       
       
       
         <Route
          path="/push-notification"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="notification-list" isAdmin={isAdmin}>
              <PushNotification />
            </PrivateRoute>
          }
        />
         <Route
          path="/push-notification-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="notification-list" isAdmin={isAdmin}>
              <PushNotificationList />
            </PrivateRoute>
          }
        />
       
        <Route
          path="/admin-user"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <AdminUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-admin-user"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <AddAdmin />
            </PrivateRoute>
          }
        />
          <Route
          path="/profile"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="profile" isAdmin={isAdmin}>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-banner"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="app-banner-list" isAdmin={isAdmin}>
              <AddBanner />
            </PrivateRoute>
          }
        />
        <Route
          path="/app-banner-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="app-banner-list" isAdmin={isAdmin}>
              <Banner />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-category"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="category-list" isAdmin={isAdmin}>
              <AddCategory />
            </PrivateRoute>
          }
        />
         <Route
          path="/refer"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="settings" isAdmin={isAdmin}>
              <Refer />
            </PrivateRoute>
          }
        />
        <Route
          path="/category-list"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated} requiredPermission="category-list" isAdmin={isAdmin}>
              <Category />
            </PrivateRoute>
          }
        />
      </Routes>
      {isAuthenticated && <Footer />}
    </Router>
  );
}

export default App;
// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Login from './component/Auth/Login';
// import Dashboard from './component/Dashboard';
// import Booking from './component/Booking';
// import InvestorList from './component/InvestorList';
// import AddInvestor from './component/Add Model/AddInvestor';
// import InvestorEarning from './component/InvestorEarning';
// import InvestorWithdrawal from './component/InvestorWithdrawal';
// import CottageList from './component/CottageList';
// import AddNewCottage from './component/Add Model/AddNewCottage';
// import CouponCode from './component/CouponCode';
// import AddNewCouponCode from './component/Add Model/AddNewCouponCode';
// import CouponUserManagement from './component/CouponUserManagement';
// import InventoryList from './component/InventoryList';
// import AddRoom from './component/Add Model/AddRoom';
// import ManageReview from './component/ManageReview';
// import FaqList from './component/FaqList';
// import AddFAQ from './component/Add Model/AddFaq';
// import FaqCategory from './component/FaqCategory';
// import AddFAQCategory from './component/Add Model/AddFaqCategory';
// import Contact from './component/Contact';
// import Header from './component/Header/Header';
// import Footer from './component/Header/Footer';
// import SideBar from './component/Header/SideBar';
// import UserManager from './component/UserManager';
// import Notification from './component/Notification';
// import AddNotification from './component/Add Model/AddNotification';

// import AddBanner from './component/Add Model/AddBanner';
// import UserAdd from './component/Add Model/UserAdd';
// import Banner from './component/Banner';


// import Profile from './component/Profile';
// import PrivacyPolicy from './component/PrivacyPolicy';
// import TermCondition from './component/TermAndCondition';
// import Feedback from './component/Feedback';
// import AddAdmin from './component/Add Model/AddAdmin';
// import AdminUser from './component/AdminUser';
// import PushNotification from './component/PushNotification';
// import PushNotificationList from './component/PushNotificationList';

// import UserPermission from './component/UserPermission';
// import RefundPolicy from './component/RefundPolicy';

// import TrialPeriod from './component/TrialPeriod';
// import AppSettings from './component/AppSettings';
// import EmailNotification from './component/EmailNotification';
// import TicketManagement from './component/TicketManagement';




// const PrivateRoute = ({ children, isAuthenticated, role, requiredRole }) => {
//   if (isAuthenticated === null) {
//     return <div>Loading...</div>; // Or any other loading indicator
//   }
//   if (!isAuthenticated) {
//     return <Navigate to="/" />;
//   }
//   if (requiredRole && !requiredRole.includes(role)) {
//     return <Navigate to="/dashboard" />; // Or an appropriate "not authorized" page
//   }
//   return children;
// };

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(null);
//   const [role, setRole] = useState(null);

//   useEffect(() => {
//     // Check if the user is authenticated and get their role
//     const token = localStorage.getItem('authToken');
//     const userRole = localStorage.getItem('userRole'); // Assuming role is stored in local storage
//     if (token && userRole) {
//       setIsAuthenticated(true);
//       setRole(userRole);
//     } else {
//       setIsAuthenticated(false);
//     }
//   }, [role]);

//   return (
//     <Router>
//       {/* {isAuthenticated && <SideBar />} */}
//       {isAuthenticated && <Header />}
//       <Routes>
//         <Route
//           path="/"
//           element={
//             isAuthenticated ? <Navigate to="/dashboard" /> : <Login setIsAuthenticated={setIsAuthenticated} setRole={setRole} />
//           }
//         />
//         <Route
//           path="/dashboard"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <Dashboard />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/booking"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <Booking />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/investor-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <InvestorList />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-investor"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddInvestor />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/investor-earning"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <InvestorEarning />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/investor-withdrawal"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <InvestorWithdrawal />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/cottage-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <CottageList />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-new-cottage"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddNewCottage />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/coupon-code"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <CouponCode />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-new-coupon-code"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddNewCouponCode />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/coupon-user-management"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <CouponUserManagement />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/inventory-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <InventoryList />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-room"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddRoom />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/manage-review"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <ManageReview />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/faq-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <FaqList />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-faq"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddFAQ />
//             </PrivateRoute>
//           }
//         />
//          <Route
//           path="/faq-category-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <FaqCategory />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-faq-category"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddFAQCategory />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/contact"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <Contact />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/ticket-management"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <TicketManagement />
//             </PrivateRoute>
//           }
//         />
//          {/* <Route
//           path="/about-us"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <AboutUs />
//             </PrivateRoute>
//           }
//         />  */}
//         <Route
//           path="/user-add"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <UserAdd />
//             </PrivateRoute>
//           }
//         /> 
//         <Route
//           path="/privacy-policy"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <PrivacyPolicy />
//             </PrivateRoute>
//           }
//         />
//           <Route
//           path="/term-and-condition"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <TermCondition />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="refund-policy"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <RefundPolicy />
//             </PrivateRoute>
//           }
//         />
//           <Route
//           path="/user-permission"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <UserPermission />
//             </PrivateRoute>
//           }
//         />
//            <Route
//           path="/feedback"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <Feedback />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/user-manager"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <UserManager />
//             </PrivateRoute>
//           }
//         />
      
//         <Route
//           path="/trial-period"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <TrialPeriod />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/notification-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <Notification />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-notification"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddNotification />
//             </PrivateRoute>
//           }
//         />
       
       
       
//          <Route
//           path="/push-notification"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <PushNotification />
//             </PrivateRoute>
//           }
//         />
//          <Route
//           path="/push-notification-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <PushNotificationList />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/app-settings"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <AppSettings />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/email-notification"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <EmailNotification />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/admin-user"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AdminUser />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-admin-user"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <AddAdmin />
//             </PrivateRoute>
//           }
//         />
//           <Route
//           path="/profile"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin']}>
//               <Profile />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/add-banner"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <AddBanner />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/app-banner-list"
//           element={
//             <PrivateRoute isAuthenticated={isAuthenticated} role={role} requiredRole={['Admin', 'human']}>
//               <Banner />
//             </PrivateRoute>
//           }
//         />
       
         
      
         
       
//       </Routes>
//       {isAuthenticated && <Footer />}
//     </Router>
//   );
// }

// export default App;
